export default value => value.charAt(0) !== ".";
